module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAAG0lEQVR4AWMgBoyCUXCB4T8WeIFyDZhgFIwCADUtFy0dacqMAAAAAElFTkSuQmCC"